import React from "react";

/**
 * 📋 Encabezado de la tabla de configuración de reportes
 *
 * - Visualmente alineado con el cuerpo (td)
 * - Mismo padding, ancho y tipografía
 * - Compatible con modo oscuro
 */
const ReportProfileTableHeader: React.FC = () => {
  return (
    <thead className="bg-gray-100 dark:bg-gray-800">
      <tr className="dark:border-gray-700">
        {/* 🔢 Número */}
        <th
          scope="col"
          className="w-20 text-center px-6 py-4 text-[15px] sm:text-base font-semibold text-gray-900 dark:text-gray-200 border-b border-stroke dark:border-gray-700"
        >
          #
        </th>

        {/* 🧩 Código */}
        <th
          scope="col"
          className="px-6 py-4 text-left text-[15px] sm:text-base font-semibold text-gray-900 dark:text-gray-200 border-b border-stroke dark:border-gray-700"
        >
          Código
        </th>

        {/* 📄 Nombre */}
        <th
          scope="col"
          className="px-6 py-4 text-left text-[15px] sm:text-base font-semibold text-gray-900 dark:text-gray-200 border-b border-stroke dark:border-gray-700"
        >
          Nombre
        </th>

        {/* ⚙️ Estado */}
        <th
          scope="col"
          className="w-40 text-center px-6 py-4 text-[15px] sm:text-base font-semibold text-gray-900 dark:text-gray-200 border-b border-stroke dark:border-gray-700"
        >
          Estado
        </th>
      </tr>
    </thead>
  );
};

export default ReportProfileTableHeader;
